export enum ProfileTypes {
	LOADING_PROFILE = 'Profile/loading',
	EDIT_PROFILE = 'Profile/Edit',
	PROFILE_FAIL = 'Profile/Fail',
	PROFILE_SUCCESS = 'Profile/Success',
	PROFILE_PASSWORD_RESET = 'Password/Reset',
	UPDATE_BILLING_AND_SHIPPING = 'Profile/Billing/Shipping',
	UPDATE_BILLING_AND_SHIPPING_FAIL = 'Profile/Billing/Shipping/Fail',
	LOAD_PROFILE_SUCCESS = 'PROFILE/SUCCESS',
	LOAD_BILLING_AND_SHIPPING = 'LOAD?BILLING/SHIPPING',
	LOAD_ALL_KIDS = 'LOAD/ALL/KIDS',
	ACTIVATE_WELCOME = 'ACTIVATE?WELCOME',
	FORGOT_PASSWORD = 'FORGOT_PASSWORD',
	CLEAR_ADDRESS = 'CLEAR_ADDRESS'
}

export type children = {
	id: number;
	fullName: string;
	status: string;
	gender: string;
};

export type UserProfile = {
	fullName: string;
	email: string;
	isSameAddress:boolean;
	Children: children[];
};

export type KidsList = {
	childrens: children[];
};
export type forgotPasswordMessage= {
	message:string;
}
export interface LoadBillingAndShipping {
	address: string | undefined;
	city: string | undefined;
	state: string | undefined;
	zipCode: string | undefined;
	phoneNumber: string | undefined;
	SAddress: string | undefined;
	shipping_address: string | undefined;
	SCity: string | undefined;
	shipping_city: string | undefined;
	SState: string | undefined;
	shipping_state: string | undefined;
	SzipCode: string | undefined;
	shipping_zipCode: string | undefined;
	sphoneNumber: string | undefined;
	shipping_phoneNumber: string | undefined;
	fullName?: string | undefined;
	isSameAddress?:boolean | undefined;
	loading?: any;
}
export interface ProfileLoading {
	type: typeof ProfileTypes.LOADING_PROFILE;
}

export interface ProfileFAIL {
	type: typeof ProfileTypes.PROFILE_FAIL;
	error: {
		errors: any | undefined;
	};
}

export interface ProfileSuccess {
	type: typeof ProfileTypes.PROFILE_SUCCESS;
}
export interface ResetPassword {
	type: typeof ProfileTypes.PROFILE_PASSWORD_RESET;
}
export interface BillingAndShipping {
	type: typeof ProfileTypes.UPDATE_BILLING_AND_SHIPPING;
}
export interface BillingAndShippingFAIL {
	type: typeof ProfileTypes.UPDATE_BILLING_AND_SHIPPING_FAIL;
	error: {
		errors: any | undefined;
	};
}
export interface LoadProfileSuccess {
	type: typeof ProfileTypes.LOAD_PROFILE_SUCCESS;
	payload: UserProfile;
}
export interface LoadBillingAndShippingInterface {
	type: typeof ProfileTypes.LOAD_BILLING_AND_SHIPPING;
	payload: LoadBillingAndShipping;
}
export interface loadAllChildren {
	type: typeof ProfileTypes.LOAD_ALL_KIDS;
	payload: KidsList;
}
export interface ActivateWelcome {
	type: typeof ProfileTypes.ACTIVATE_WELCOME;
}
export interface ForgotPassword {
	type: typeof ProfileTypes.FORGOT_PASSWORD;
	payload:forgotPasswordMessage;
}
export  interface clearAddress {
	type: typeof ProfileTypes.CLEAR_ADDRESS
}
export type ProfileDispatchTypes =
	| ProfileLoading
	| ProfileFAIL
	| ProfileSuccess
	| ResetPassword
	| BillingAndShipping
	| BillingAndShippingFAIL
	| LoadProfileSuccess
	| LoadBillingAndShippingInterface
	| loadAllChildren
	| ActivateWelcome
	| clearAddress
	| ForgotPassword;
